import { useState, useEffect, useCallback } from 'react';

const getCountdownColor = (diffMs) => {
    if (diffMs < 0) return '#ef4444';
    const hours = diffMs / 3600000;
    if (hours < 1) return '#ef4444';
    if (hours < 2) return '#f97316';
    return '#22c55e';
};

const CountdownTime = ({ until, style }) => {
    const [display, setDisplay] = useState('');
    const [diffMs, setDiffMs] = useState(0);

    const calculate = useCallback(() => {
        if (!until) return { text: '', ms: 0 };

        const ms = new Date(until).getTime() - Date.now();
        const absDiffMs = Math.abs(ms);
        const totalMins = Math.floor(absDiffMs / 60000);
        const hours = Math.floor(totalMins / 60);
        const minutes = totalMins % 60;

        let text;
        if (hours > 0) text = `${hours}h ${minutes}m`;
        else text = `${minutes}m`;

        if (ms < 0) text = `+${text}`;
        return { text, ms };
    }, [until]);

    useEffect(() => {
        if (!until) return;

        const update = () => {
            const result = calculate();
            setDisplay(result.text);
            setDiffMs(result.ms);
        };

        update();
        const interval = setInterval(update, 60000);
        return () => clearInterval(interval);
    }, [until, calculate]);

    if (!until) return <span style={style}>-</span>;

    const color = getCountdownColor(diffMs);

    return (
        <span title="Time remaining until flight departure" style={{ display: 'inline-flex', alignItems: 'center', gap: 5, color, cursor: 'default', ...style }}>
            <span style={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: color,
                flexShrink: 0,
            }} />
            {display}
        </span>
    );
};

export default CountdownTime;
